import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';

export const Drawer = (props: MuiDrawerProps): JSX.Element => {
  return <MuiDrawer {...props} />;
};

export default Drawer;
